// §11.7 / §9.1 — Photos as an in-process app.
//
// It claims the image extensions as a **viewer**, not an editor (D-018): "Open with" should offer
// PixelSmith the moment it is installed, and a viewer that called itself an editor would sit in
// front of it in the registry's ordering.
import { createRoot, type Root } from 'react-dom/client';
import type { InProcessApp, PhotosShellAccess } from '@hangar/shared';
import { Photos, PHOTO_EXTENSIONS } from './Photos';
import './photos.css';

const roots = new WeakMap<HTMLElement, Root>();

export function createPhotosApp(access: PhotosShellAccess): InProcessApp {
  return {
    id: 'photos',
    name: 'Photos',
    icon: { glyph: 'image', hue: 325 },
    keywords: ['image', 'picture', 'viewer', 'photo', 'wallpaper'],
    window: { width: 900, height: 640, minWidth: 380, minHeight: 280, multiWindow: true },
    fileTypes: [
      {
        ext: PHOTO_EXTENSIONS,
        mime: ['image/png', 'image/jpeg', 'image/gif', 'image/webp', 'image/avif', 'image/bmp'],
        role: 'viewer',
      },
    ],

    mount(container, api) {
      const root = createRoot(container);
      roots.set(container, root);
      root.render(<Photos api={api} access={access} />);
    },

    unmount(container) {
      const root = roots.get(container);
      roots.delete(container);
      root?.unmount();
    },
  };
}
